import React from 'react';
// Direct file imports, not the `@koob/checkout` barrel: that barrel also
// exports the Checkout* modal components, which pull in `@koob/ui`'s full
// barrel (KoobInputDate → react-day-picker → date-fns/locale.js, a raw ESM
// file jest cannot parse) into every consumer of this package.
import formatHotelRoomBed from '@koob/checkout/src/utilities/formatHotelRoomBed';
import formatHotelRoomName from '@koob/checkout/src/utilities/formatHotelRoomName';

const getRoomLabel = (room: any) =>
  formatHotelRoomName(room, { name: formatHotelRoomBed(room) } as any);

export default function TripDayHotelRoomList({
  dayIndex,
  roomsLoading,
  roomsFetching,
  roomsData,
  dayRoomSelection,
  displayedRooms,
  isRoomUnavailable,
  canEditRoomSelection = true,
  canEditRoomComposition = true,
  onEditRoomSelection,
  onEditRooms,
  t,
}: {
  dayIndex: number;
  roomsLoading: boolean;
  roomsFetching: boolean;
  roomsData: any;
  dayRoomSelection: any;
  displayedRooms: any[];
  isRoomUnavailable: any;
  // DMC only: both default to true — TO has no ownership/previousBooking
  // concept, so it always sees both controls.
  canEditRoomSelection?: boolean;
  canEditRoomComposition?: boolean;
  onEditRoomSelection: () => void;
  onEditRooms: () => void;
  t: (key: string, options?: Record<string, any>) => string;
}) {
  return (
    <>
      {canEditRoomSelection && (
        <button
          type="button"
          className="text-left text-blue-500 hover:text-orange-500 transition border-0 cursor-pointer"
          onClick={(e: any) => {
            e.preventDefault();
            onEditRoomSelection();
          }}
          title={t('tooltip.editRoomSelection')}
          data-testid={`edit-room-selection-day-${dayIndex}`}
        >
          {roomsLoading || roomsFetching ? (
            <div className="text-xs text-gray-500">Loading rooms...</div>
          ) : roomsData?.cheapestRoom || dayRoomSelection ? (
            <div className="flex flex-col">
              <div className="flex space-x-1 items-center">
                <div className="text-xs">
                  {dayRoomSelection?.allRooms?.length > 1
                    ? dayRoomSelection.allRooms
                        .map(
                          (room: any, idx: number) =>
                            getRoomLabel(room) ||
                            t('compose.room', { index: idx + 1 }),
                        )
                        .join(' + ')
                    : getRoomLabel(dayRoomSelection?.roomData) ||
                      (roomsData?.cheapestRooms?.length > 1
                        ? roomsData.cheapestRooms
                            .map(
                              (room: any, idx: number) =>
                                getRoomLabel(room) ||
                                t('compose.room', { index: idx + 1 }),
                            )
                            .join(' + ')
                        : getRoomLabel(roomsData?.cheapestRoom))}
                </div>
                {(roomsData?.possibilities?.length > 0 ||
                  isRoomUnavailable) && (
                  <i className="fa-light fa-pen" style={{ fontSize: 18 }} />
                )}
              </div>
            </div>
          ) : null}
        </button>
      )}

      {canEditRoomComposition && (
        <div className="mt-1 flex flex-wrap items-center gap-x-2 text-xs text-gray-600">
          <span>
            {t('compose.stayRooms.summary', {
              rooms: displayedRooms.length,
              pax: displayedRooms.reduce(
                (sum: number, room: any) => sum + room.adults + room.children,
                0,
              ),
            })}
          </span>
          <button
            type="button"
            className="p-0 bg-transparent text-blue-500 hover:text-orange-500 transition border-0 cursor-pointer"
            onClick={(e: any) => {
              e.preventDefault();
              onEditRooms();
            }}
          >
            {t('compose.stayRooms.edit')}
          </button>
        </div>
      )}
    </>
  );
}
